import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { translate } from 'secullum-i18n';
import CardSolicitarAjuda, {
  CardSolicitarAjudaProps
} from '../../../shared/components/CardSolicitarAjuda';
import Api from '../../../shared/modules/api';
import LoggedInScreen from '../../components/LoggedInScreen';

interface Props extends RouteComponentProps {}

class SolicitarAjuda extends React.Component<Props> {
  api = new Api();

  usuarioLogado() {
    return this.api.funcionario.state.dados.id !== 0;
  }

  renderCardAjuda() {
    const { history, location } = this.props;

    const state = location.state as CardSolicitarAjudaProps;

    return (
      <CardSolicitarAjuda
        {...state}
        usuarioLogado={this.usuarioLogado()}
        onNavegar={history.goBack}
      />
    );
  }

  render() {
    if (this.usuarioLogado()) {
      return (
        <LoggedInScreen screenTitle={translate('Solicitar Ajuda')}>
          {this.renderCardAjuda()}
        </LoggedInScreen>
      );
    }

    return (
      <View style={styles.container}>
        <View style={styles.cardForm}>{this.renderCardAjuda()}</View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: '#59CBE8',
    paddingBottom: 0,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  cardForm: {
    flexDirection: 'column',
    flexBasis: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: 345
  }
});

export default withRouter(SolicitarAjuda);
